import { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { User } from 'firebase/auth';

/**
 * Hook para obter o ID do usuário atual logado via Google
 */
export const useCurrentUserId = () => {
  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      setLoading(true);

      if (firebaseUser) {
        // Usar o UID do Firebase como identificador único
        setUserId(firebaseUser.uid);
        setUser(firebaseUser);
        console.log('[DEBUG] User ID obtido:', firebaseUser.uid);
        console.log('[DEBUG] User email:', firebaseUser.email);
      } else {
        setUserId(null);
        setUser(null);
        console.log('[DEBUG] Usuário não logado');
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return {
    userId,
    user,
    loading,
    isLoggedIn: !!userId,
    userEmail: user?.email || null,
    userName: user?.displayName || null,
    userPhoto: user?.photoURL || null
  };
};